'use strict'; //

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _jquery = require("jquery");

var _component = _interopRequireDefault(require("../core/component"));

var _enhance = _interopRequireDefault(require("../core/enhance"));

var _tools = _interopRequireDefault(require("../libs/tools"));

var _http = _interopRequireDefault(require("./http"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

/**
 * Cache 组件监听缓存变化
 * 在html5plus 中每个webview都会接收到缓存更新事件
 */
var Cache = /*#__PURE__*/function (_Component) {
  _inheritsLoose(Cache, _Component);

  function Cache(props) {
    var _this;

    _this = _Component.call(this, props) || this;
    _this.state = {
      name: [],
      names: []
    };

    _this.handlerCacheEvent = function (name, params) {
      var key = name + '?' + _tools.default.http_build_query(params);

      if (_this.state.names.indexOf(key) > -1) {
        var event = {};
        event[name] = _tools.default.storage.getItem(name, params);
        _this.props.onUpdate && _this.props.onUpdate(event);
      }
    };

    (0, _jquery.extend)(_this.state, props, true);
    var names = [];

    for (var i in _this.state.name) {
      names.push(i + '?' + _tools.default.http_build_query(_this.state.name[i]));
    }

    _this.state.names = names;
    return _this;
  }
  /**
   * componentDidMount()在挂载结束之后马上被调用。需要DOM节点的初始化操作应该放在这里。
   */


  var _proto = Cache.prototype;

  _proto.componentDidMount = function componentDidMount() {
    this._on('Cache', this.handlerCacheEvent);
  }
  /**
   * 在组件从 DOM 中移除的时候立刻被调用。
   */
  ;

  _proto.componentWillUnmount = function componentWillUnmount() {
    this._un('Cache', this.handlerCacheEvent);
  }
  /**
   * 输入参数 nextProps 是即将被设置的属性，
   * 旧的属性还是可以通过 this.props 来获取。
   * 在这个回调函数里面，你可以根据属性的变化，
   * 通过调用 this.setState() 来更新你的组件状态，这里调用更新状态是安全的，
   * 并不会触发额外的 render() 调用
   */
  ;

  _proto.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    (0, _jquery.extend)(this.state, nextProps, true);
  }
  /**
   *
   * @returns {null}
   */
  ;

  _proto.render = function render() {
    return null;
  }
  /**
   *
   * @param name
   * @param data
   * @private
   */
  ;

  return Cache;
}(_component.default);

Cache.displayName = "Cache";
var _default = Cache;
exports.default = _default;
module.exports = exports.default;